import React from 'react'
import styled from 'styled-components'
import White from '../white'
import Container from '../container'
import Portable from '../portable'

const Wrapper = styled.div`
  width: 100%;
  h2 {
    max-width: 100%;
    margin-bottom: 132px;
  }
`

const Row = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  column-gap: 100px;
  &.reverse {
    flex-direction: row-reverse;
  }
  @media(max-width: 768px) {
    flex-direction: column;
  }
`

const Col = styled.div`
  width: 50%;
  h3 {
    margin-bottom:40px;
  }
  img {
    border-radius: 16px;
  }
  @media(max-width: 768px) {
    width: 100%;
  }
`

const ImageText = props => {

  const { module } = props;

  return (
    <White>
      <Container>
        <Wrapper>
          <Row className={module.swap_image_text ? 'reverse' : 'normal'}>
            <Col><img src={module.image.asset.publicUrl} /></Col>
            <Col>
              {module.heading &&
                <h3>{module.heading}</h3>
              }
              <Portable blocks={module.body} /></Col>
          </Row>
        </Wrapper>
      </Container>
    </White>
  )
}

export default ImageText
